export enum Position {
	Top,
	Bottom,
	Left,
	Right,
}

export const shadowByPosition = (
	position: Position,
	shadowStyle: Record<"left" | "right", string>
): string | undefined => {
	switch (position) {
		case Position.Left:
			return shadowStyle.left;
		case Position.Right:
			return shadowStyle.right;
		default:
			return undefined;
	}
};
